import React from "react";

import {
    FormControl,
    FormControlLabel,
    RadioGroup as RadioGroupMUI,
    Radio,
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';
import { Typography } from "@mui/material";

const useStyles = makeStyles((theme) => ({
    radio: {
        '&$checked': {
            color: '#155BCB'
        }
    },
    checked: {},
}));

export default function RadioGroup({ format, setFormat, title = 'Formato do Relatório: ' }) {

    const classes = useStyles();

    const controlProps = (item) => ({
        checked: format === item,
        onChange: handleChange,
        value: item,
        inputProps: { 'aria-label': item },
    });

    const handleChange = (event) => {
        setFormat(event.target.value);
    };

    return (
        <>
            <Typography style={{ textAlign: 'center', color: '#333', fontWeight: 700, fontFamily: 'Rawline' }}>{title}</Typography>

            <FormControl component="fieldset">
                <RadioGroupMUI row>
                    <FormControlLabel value=".pdf" control={<Radio
                        {...controlProps('PDF')}
                        classes={{ root: classes.radio, checked: classes.checked }}
                    />} label="PDF" />
                    <FormControlLabel value=".xls" control={<Radio
                        {...controlProps('XLS')}
                        classes={{ root: classes.radio, checked: classes.checked }}
                    />} label="XLS" />
                    <FormControlLabel value=".html" control={<Radio
                        {...controlProps('HTML')}
                        classes={{ root: classes.radio, checked: classes.checked }}
                    />} label="HTML" />
                </RadioGroupMUI>
            </FormControl>
        </>
    )


}